export default "__VITE_ASSET__iKAVHiUG__"